import { React } from 'react';
import { styled } from '@mui/system';
import { Card } from '@mui/material';
import NoteInfo from '../NoteInfo';
import NotePictures from '../NotePictures';

const NoteContainer = styled(Card)(({ theme }) => ({
  maxWidth: '825px',
  height: '600px',
  border: '1px solid #ffff',
  background:
    'linear-gradient(250.42deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.08) 101.65%)',
  padding: '10px',
  display: 'flex',
  margin: '20px auto 25px',

  '&>div:first-of-type': {
    width: '54%',
    height: 'inherit',
  },
  '&>div:last-child': {
    //  width: '46%',
  },
  flexWrap: 'wrap',
  flexDirection: 'column',
  gap: 'px',

  width: '825px',
  boxSizing: 'fit-content',

  // [theme.breakpoints.down('900')]: {
  //   width: '680px',
  // },

  [theme.breakpoints.down('950')]: {
    width: '700px',
    height: '620px',
  },
  [theme.breakpoints.down('750')]: {
    //   display: 'flex',
    flexWrap: 'nowrap ',
    //   justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100vw',
    //   alignItems: 'center',
    height: 'auto',
    boxShadow: 'none',
    border: 'none',
    padding: '0',
    margin: '0px',

    '&>div:first-of-type': {
      width: '100%',
    },
  },
}));

const CardsSection = styled('div')(({ theme }) => ({
  display: 'flex',

  [theme.breakpoints.down('500')]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    // textAlign: 'center',
    flexWrap: 'wrap',
    margin: '0px',
  },
}));

const Note = ({ noteData }) => {
  return (
    <CardsSection>
      <NoteContainer elevation={3}>
        <NotePictures notePics={noteData.attachments} />
        <NoteInfo noteData={noteData} />
      </NoteContainer>
    </CardsSection>
  );
};

export default Note;
